import chudaroglu from "../static files/images/cuhadaroglu-aluminyum-sanayi-ve-ticaret-st-70-aluminium-windows-archello.1646833752.1124.png";

// const DetailCard = () => {
//   return (
//     <article className="card">
//       <div className="image-wrapper">
//         <img src={chudaroglu} alt="chudaroglu" />
//       </div>
//       <h4>Cuhadaroğlu ST 60 / ST 70</h4>
//     </article>
//   );
// };

// export default DetailCard;
const DetailCard = ({ prod, onClick, isActive }) => {
  return (
    <article className="card" onClick={onClick}>
      <div
        className="image-wrapper"
        style={{
          backgroundColor: isActive ? "#D5E5FD" : "#EFEEEC",
          transition: "0.3s",
        }}
      >
        <img src={prod.image} alt={prod.title} />
      </div>
      <h4>{prod.title}</h4>
    </article>
  );
};

export default DetailCard;
